export const AUTH_PROVIDERS = {
  FIREBASE: 'firebase',
  FIGMA_EMBED: 'figma',
} as const;

export const SIGN_IN_REDIRECT_QUERY_PARAM = 'redirect';

/** Where an `/idp-signin` visitor was going, held in sessionStorage until a sign-in succeeds. */
export const IDP_INITIATED_REDIRECT_PATH = 'idp_initiated_redirect_path';

// Trailing slash is intentional — prevents false matches on paths like /embedding
// or /embed-settings that share the prefix but aren't the embed route.
export const FIGMA_EMBED_ROUTE_PREFIX = '/embed/';

export const FIGMA_EMBED_ALLOWED_ORIGINS = [
  'https://www.figma.com',
  'https://staging.figma.com',
  'https://local.figma.engineering:8443',
];

// Coder devboxes serve Figma from generated *.figdev.systems hostnames in two shapes:
//   <workspace>.figdev.systems                            (single-label)
//   <port>--<svc>--<workspace>.coder-<region>.figdev.systems  (per-port subdomains)
// Mirrors the canonical `endsWith('.figdev.systems')` check in share/figma-url/src/hostnames.ts,
// kept as a regex here so the static allow-list above stays a strict-equality check.
export const FIGMA_EMBED_ALLOWED_ORIGIN_PATTERNS: readonly RegExp[] = [
  /^https:\/\/[a-z0-9-]+(?:\.[a-z0-9-]+)*\.figdev\.systems$/,
];

/**
 * Origin gate for postMessages claiming to come from the Figma parent (token
 * pushes, permissions pushes, etc.). Both the static allow-list and the
 * Coder-devbox regex must be considered — checking only the static list silently
 * drops legitimate messages on `*.figdev.systems` workspaces.
 */
export function isFigmaEmbedAllowedOrigin(origin: string): boolean {
  return (
    FIGMA_EMBED_ALLOWED_ORIGINS.includes(origin) || FIGMA_EMBED_ALLOWED_ORIGIN_PATTERNS.some((p) => p.test(origin))
  );
}
